// Shared month-grid geometry for the booking calendar and the admin special-days
// calendar: Monday-first offset for the 1st of the month, plus one entry per day.
// Each caller supplies its own selection/highlight/click logic — this only
// computes which grid cell is which date.
export function buildMonthDays(year, month) {
    const firstOfMonth = new Date(year, month, 1);
    const startOffset = (firstOfMonth.getDay() + 6) % 7; // Monday-first
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const cells = [];
    for (let i = 0; i < startOffset; i += 1)
        cells.push(null);
    for (let day = 1; day <= daysInMonth; day += 1)
        cells.push(new Date(year, month, day));
    return cells;
}
